import { useEffect, useState } from "react";
import api from "../constant/api";
import { Html5QrcodeScanner } from "html5-qrcode";
import { openDB } from "idb";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";


export default function POS() {

  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [search, setSearch] = useState("");
  const [showScanner, setShowScanner] = useState(false);
  const [customers, setCustomers] = useState([]);
const [customerSearch, setCustomerSearch] = useState("");
const [selectedCustomer, setSelectedCustomer] = useState(null);
const [showCustomerList, setShowCustomerList] = useState(false);
const [showAddCustomer, setShowAddCustomer] = useState(false);
 const [quotationId, setQuotationId] = useState(null);
  const [sessionActive, setSessionActive] = useState(false);
   const [selectPayment, setSelectPayment] = useState(null);
    const [productErrors, setProductErrors] =
  useState({});

   const [showProductModal,
    setShowProductModal] =
    useState(false);

 console.log('selectPayment',selectPayment)   
const [billDate, setBillDate] = useState("");

const [selectedBranch, setSelectedBranch] = useState(
  localStorage.getItem("selectedBranch") || ""
);

const [selectedBranchName, setSelectedBranchName] = useState(
  localStorage.getItem("selectedBranchName") ||
  ""
);

useEffect(() => {
  const handleBranchChanged = (event) => {
    const branchId =
      event.detail?.branchId ||
      localStorage.getItem("selectedBranch") ||
      "";

    const branchName =
      event.detail?.branchName ||
      localStorage.getItem("selectedBranchName") ||
      "A K Ceramic World";

  

    setSelectedBranch(branchId);
    setSelectedBranchName(branchName);
  };

  window.addEventListener(
    "branchChanged",
    handleBranchChanged
  );

  // Initial value
  const currentBranchId =
    localStorage.getItem("selectedBranch") || "";

  const currentBranchName =
    localStorage.getItem("selectedBranchName") ||
    "A K Ceramic World";

  setSelectedBranch(currentBranchId);
  setSelectedBranchName(currentBranchName);

  return () => {
    window.removeEventListener(
      "branchChanged",
      handleBranchChanged
    );
  };
}, []);

// useEffect(() => {
//   localStorage.setItem(
//     "selectedBranch",
//     selectedBranch
//   );
// }, [selectedBranch]);

// console.log("location",selectedBranch)

  useEffect(() => {
  const today = new Date().toISOString().split("T")[0];
  setBillDate(today);
}, []);


 const [suppliers, setSuppliers] = useState([]);
    useEffect(() => {
    getSuppliers();
  }, []);

  const getSuppliers = async () => {
    try {
      const res = await api.get("Product/getSuppliers");
      setSuppliers(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

const [newCustomer, setNewCustomer] = useState({
  name: "",
  phone: "",
  gst_no:"",
  email: "",
  address: ""
});

// 🔥 LOAD CART FROM DB (important)
useEffect(() => {
  if (!quotationId) return;

  const loadItems = async () => {
    try {
      const res = await api.get(`/Ecom/getQuotationItems/${quotationId}`);

      const data = res.data.data || [];

   const formatted = data.map(i => ({
  product_id: i.product_id,
  name: i.product_name,
  rate: i.price,

  box: i.qty || 0,

  // ✅ IMPORTANT
  pic: i.pic || 0,

  pcs_per_box: i.pcs_per_box || 1,

  sqft_per_box: Number(i.sqft_per_box || 0),

  // ✅ IMPORTANT
  sqft_per_pcs: Number(i.sqft_per_pcs || 0)
}));

      setCart(formatted);

    } catch (err) {
      console.log(err);
    }
  };

  loadItems();

}, [quotationId]);



const [productForm, setProductForm] =
  useState({
    product_name: "",
    description: "",
    price: "",
    qty: "",
    pic: "",
    mrp: "",
    size: "",
    brand: "",
    finish: "",
    pcs_per_box: "",
    sqft_per_box: "",
    sqft_per_pcs: "",
    branch: "",
     supplier_id:""
  });

/* ====================================== */
/* HANDLE CHANGE */
/* ====================================== */

const handleProductChange = (e) => {

  setProductForm({
    ...productForm,
    [e.target.name]: e.target.value,
  });

  setProductErrors({
    ...productErrors,
    [e.target.name]: "",
  });

};

/* ====================================== */
/* VALIDATE */
/* ====================================== */

const validateProduct = () => {

  let errors = {};

  if (
    !productForm.product_name.trim()
  ) {
    errors.product_name =
      "Product name required";
  }

  if (!productForm.brand) {
    errors.brand =
      "Please select brand";
  }

  if (!productForm.price) {
    errors.price =
      "Price required";
  }

  if (!productForm.qty) {
    errors.qty =
      "Qty required";
  }

  if (!productForm.finish) {
    errors.finish =
      "Select finish";
  }

  if (!productForm.branch) {
    errors.branch =
      "Select branch";
  }

  if (!productForm.pcs_per_box) {
    errors.pcs_per_box =
      "Pcs per box required";
  }

  if (!productForm.sqft_per_box) {
    errors.sqft_per_box =
      "Sqft per box required";
  }

  if (!productForm.sqft_per_pcs) {
    errors.sqft_per_pcs =
      "Sqft per pcs required";
  }

  setProductErrors(errors);

  return (
    Object.keys(errors).length === 0
  );

};

/* ====================================== */
/* SAVE PRODUCT */
/* ====================================== */

const saveProduct = async () => {

  if (!validateProduct()) return;

  try {

    const formData =
      new FormData();

    Object.keys(productForm).forEach(
      (key) => {
        formData.append(
          key,
          productForm[key]
        );
      }
    );

    await api.post(
      "/Product/insertProduct",
      formData
    );

    toast.success(
      "Product Added"
    );

    setShowProductModal(false);

  } catch (err) {

    console.log(err);

    toast.error(
      "Failed to add product"
    );

  }

};


const getQuotationItems = () => {
  api.get(`/Ecom/getQuotationItems/${quotationId}`);
  }

useEffect(() => {
  const savedId = localStorage.getItem("quotationId");
  if (savedId) {
    setQuotationId(savedId);
    setSessionActive(true);
  }
}, []);



  // ================= OFFLINE DB =================
  const dbPromise = openDB("ak-pos-db", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("products")) {
        db.createObjectStore("products", { keyPath: "product_id" });
      }
      if (!db.objectStoreNames.contains("pendingBills")) {
        db.createObjectStore("pendingBills", { autoIncrement: true });
      }
    }
  });

  // ================= FETCH =================
  useEffect(() => {
    api.get("/Product/getProduct")
      .then(async res => {
        const data = res.data.data || [];
        setProducts(data);

        const db = await dbPromise;
        const tx = db.transaction("products", "readwrite");
        data.forEach(p => tx.store.put(p));
        await tx.done;
      })
      .catch(async () => {
        const db = await dbPromise;
        const data = await db.getAll("products");
        setProducts(data);
      });
  }, []);

  const addProductScan = async (p) => {

  if (!quotationId) {
    alert("Click START first ⚠️");
    return;
  }

  // 🔥 use latest state
  setCart((prevCart) => {

    const exist = prevCart.find(
      (i) => i.product_id === p.product_id
    );

    // =========================
    // ✅ PRODUCT EXISTS
    // =========================
    if (exist) {

      const newQty = Number(exist.box) + 1;
        const sqft =
        newQty * Number(exist.sqft_per_box || 1);

      // 🔥 API UPDATE
      api.post("/Ecom/updateQuotationItem", {
        quotation_id: quotationId,
        product_id: p.product_id,
        qty: newQty,
        price: p.price,
         sqft: sqft
      }).catch((err) => console.log(err));

      // 🔥 UPDATE UI
      return prevCart.map((i) =>
        i.product_id === p.product_id
          ? { ...i, box: newQty }
          : i
      );
    }

    // =========================
    // ✅ NEW PRODUCT
    // =========================
    else {

       const sqft =
        1 * Number(p.sqft_per_box || 1);

      // 🔥 INSERT API
      api.post("/Ecom/addQuotationItem", {
        quotation_id: quotationId,
        product_id: p.product_id,
        qty: 1,
        price: p.price,
        sqft: sqft
      }).catch((err) => console.log(err));

      // 🔥 ADD UI
      return [
  ...prevCart,
  {
    product_id: p.product_id,
    name: p.product_name,
    rate: p.price,

    box: 1,
    pic: 0,

    pcs_per_box: p.pcs_per_box || 1,

    sqft_per_box: Number(p.sqft_per_box || 0),

    // ✅ IMPORTANT
    sqft_per_pcs: Number(p.sqft_per_pcs || 0)
  }
];
    }
  });
};
  

  // ================= SCANNER =================
useEffect(() => {
  if (!showScanner) return;

  let isScanning = false;

  const scanner = new Html5QrcodeScanner(
    "qr-reader",
    { fps: 10, qrbox: 250 },
    false
  );

  const beep = new Audio(
    "https://actions.google.com/sounds/v1/alarms/beep_short.ogg"
  );

  scanner.render(
    async (decodedText) => {

      // 🔥 prevent multiple scans
      if (isScanning) return;
      isScanning = true;

      if (!quotationId) {
        alert("Click START first ⚠️");
        isScanning = false;
        return;
      }

      const found = products.find(
        (p) => p.product_code === decodedText
      );

      if (!found) {
        isScanning = false;
        return;
      }

      // ✅ ONLY CALL addProduct
      await addProductScan(found);

      beep.play();

      if (navigator.vibrate) {
        navigator.vibrate(100);
      }

      // 🔥 allow next scan after 1 second
      setTimeout(() => {
        isScanning = false;
      }, 5000);
    },
    () => {}
  );

  return () => {
    scanner.clear().catch(() => {});
  };
}, [showScanner, products, quotationId]);

  // ================= ADD =================
const addProduct = async (p) => {

  if (!quotationId) {
    alert("Click START first ⚠️");
    return;
  }

  // 🔥 find existing item
  const exist = cart.find(
    (i) => i.product_id === p.product_id
  );

  // =========================
  // ✅ PRODUCT ALREADY EXISTS
  // =========================
  if (exist) {

    const newQty = Number(exist.box) + 1;
     const sqft =
        newQty * Number(exist.sqft_per_box || 1);

    // ✅ UI UPDATE
    const updatedCart = cart.map((i) =>
      i.product_id === p.product_id
        ? { ...i, box: newQty }
        : i
    );

    setCart(updatedCart);

    try {

      // ✅ UPDATE QTY ONLY
      await api.post("/Ecom/updateQuotationItem", {
        quotation_id: quotationId,
        product_id: p.product_id,
        qty: newQty,
        price: p.price,
        sqft:sqft
      });

    } catch (err) {
      console.log(err);
    }

  }

  // =========================
  // ✅ NEW PRODUCT
  // =========================
  else {

    const newItem = {
      product_id: p.product_id,
      name: p.product_name,
      rate: p.price,
      box: 1,
      pcs_per_box: p.pcs_per_box || 1,
      sqft_per_box: p.sqft_per_box || 1,
      sqft_per_pcs: Number(p.sqft_per_pcs || 0)
    };

    // ✅ IMPORTANT
    // use callback state update
    setCart((prev) => [...prev, newItem]);

    try {
       const sqft =
        1 * Number(p.sqft_per_box || 1);

      // ✅ INSERT FIRST TIME ONLY
      await api.post("/Ecom/addQuotationItem", {
        quotation_id: quotationId,
        product_id: p.product_id,
        qty: 1,
        price: p.price, 
        sqft:sqft
      });

    } catch (err) {
      console.log(err);
    }
  }
};


 const user = JSON.parse(
    localStorage.getItem("user") || "{}"
  );

  const user_id = user.user_id;


 const handleStart = async () => {
    try {
      const res = await api.post("/Ecom/createQuotation", {
        customer_name: selectedCustomer?.name || "Walk-in",
        phone: selectedCustomer?.phone || "",
        date: billDate ,
        branch: selectedBranch,
        salesman_id: user_id
      });

      setQuotationId(res.data.quotation_id);
      localStorage.setItem("quotationId", res.data.quotation_id);
      setSessionActive(true);
      setCart([]);

    } catch (err) {
      alert("Start Failed ❌");
    }
  };

  // ================= END =================
  const handleEnd = async () => {
    if (!quotationId) return;

    try {
      await api.delete(`/Ecom/deleteQuotation/${quotationId}`);
      setQuotationId(null);
      localStorage.removeItem("quotationId");
      setCart([]);
      setSessionActive(false);
    } catch (err) {
      console.log(err);
    }
  };


  // ================= CALC =================
  // const calculateItem = (item) => {
  //   const pcs = item.box * item.pcs_per_box;
  //   const sqft = item.box * item.sqft_per_box;
  //   const total = sqft * item.rate;
  //   return { pcs, sqft, total };
  // };
const calculateItem = (item) => {

  const box =
    Number(item.box || 0);

  const pic =
    Number(item.pic || 0);

  const sqftPerBox =
    Number(item.sqft_per_box || 0);

  const sqftPerPcs =
    Number(item.sqft_per_pcs || 0);

  const rate =
    Number(item.rate || 0);

  // BOX SQFT
  const boxSqft =
    box * sqftPerBox;

  // PIC SQFT
  const picSqft =
    pic * sqftPerPcs;

  // TOTAL SQFT
  const sqft =
    boxSqft + picSqft;

  // PCS
  const pcs =
    (box * Number(item.pcs_per_box || 0))
    + pic;

  // TOTAL
  const total =
    sqft * rate;

  return {
    pcs,
    sqft,
    total
  };
};

const updateItem = async (id, field, value) => {

  const newValue = Number(value);

  // ✅ UPDATE LOCAL CART
  const updatedCart = cart.map((i) =>
    i.product_id === id
      ? { ...i, [field]: newValue }
      : i
  );

  setCart(updatedCart);

  if (!quotationId) return;

  // ✅ GET UPDATED ITEM
  const item = updatedCart.find(
    (i) => i.product_id === id
  );

  // ✅ CALCULATE NEW VALUES
  const calc = calculateItem(item);

  try {

   await api.post("/Ecom/updateQuotationItem", {
  quotation_id: quotationId,
  product_id: id,
  qty: Number(item.box || 0),
  pic: Number(item.pic || 0),
  price: Number(item.rate || 0),
  sqft: Number(calc.sqft || 0)
});

  } catch (err) {
    console.log(err);
  }
};

  // ================= DELETE =================
const removeItem = async (id) => {

  if (!quotationId) return;

  // 🔥 confirm alert
  const confirmDelete = window.confirm(
    "Are you sure want to remove this item?"
  );

  if (!confirmDelete) return;

  try {

    // 🔥 DELETE API
    const res = await api.delete(
      `/Ecom/deleteQuotationItem/${quotationId}/${id}`
    );

    // 🔥 REMOVE FROM UI
    setCart((prev) =>
      prev.filter((item) => item.product_id !== id)
    );
    getQuotationItems()
    // 🔥 SUCCESS ALERT
    alert(res.data.message || "Item removed ✅");

  } catch (err) {

    console.log(err);

    // 🔥 ERROR ALERT
    alert("Delete failed ❌");
  }
};

  // ================= TOTAL =================
  const grandTotal = cart.reduce((sum, item) => {
    return sum + calculateItem(item).total;
  }, 0);
  
const [discount, setDiscount] = useState(0);
const [gst, setGst] = useState(0);

const discountAmount =
  Number(discount || 0);

const gstAmount =
  Number(gst || 0);

const netTotal =
  grandTotal - discountAmount + gstAmount;
  // ================= SAVE =================
const saveBill = async () => {

  if (!quotationId) {
    alert("Click START first ❌");
    return;
  }

  if (!selectedCustomer) {
    alert("Select Customer ❌");
    return;
  }

  if (cart.length === 0) {
    alert("Cart Empty ❌");
    return;
  }

  try {

    // ✅ FINAL TOTAL
    const finalNetTotal =
      grandTotal
      - Number(discount || 0)
      + Number(gst || 0);

    // ✅ UPDATE QUOTATION
    await api.post(
      `/Ecom/updateQuotation/${quotationId}`,
      { 
        customer_name: selectedCustomer.name,
        phone: selectedCustomer.phone,
        gst_no: selectedCustomer.gst_no,
        address: selectedCustomer.address,
        date: billDate,

        status: "completed",

        branch: selectedBranch,

        // ✅ NEW
        total: grandTotal,

        discount: Number(discount || 0),

        customer_gst_amount:
          Number(gst || 0),

        net_total: finalNetTotal
      }
    );

    alert("Quotation Updated ✅");

    localStorage.removeItem("quotationId");

    setCart([]);
    setSelectedCustomer(null);
    setQuotationId(null);

  } catch (err) {

    console.log(err);

    alert("Update Failed ❌");
  }
};
  // ================= FILTER =================
  const filtered = products.filter(p =>
    p.product_name.toLowerCase().includes(search.toLowerCase()) ||
    p.product_code?.includes(search)
  );

  useEffect(() => {
  api.get("/Product/getCustomers").then(res => {
    setCustomers(res.data.data || []);
  });
}, []);

  const filteredCustomers = customers.filter(c =>
  c.name?.toLowerCase().includes(customerSearch.toLowerCase()) ||
  c.phone?.includes(customerSearch)
);

  const handleAddCustomer = () => {
  api.post("/Product/addCustomer", newCustomer).then(() => {
    setShowAddCustomer(false);
    setNewCustomer({ name: "", phone: "",gst_no: "", email: "", address: "" });
    
    // refresh
    api.get("/Product/getCustomers").then(res => {
      setCustomers(res.data.data || []);
    });
  });
};

const sendWhatsAppBill = () => {

  if (
    !selectedCustomer ||
    !selectedCustomer.phone
  ) {

    alert("Customer phone missing ❌");
    return;

  }

  if (cart.length === 0) {

    alert("Cart empty ❌");
    return;

  }

  // =========================
  // TOTALS
  // =========================

  const discountAmount =
    Number(discount || 0);

  const gstAmount =
    Number(gst || 0);

  const netTotal =
    grandTotal
    - discountAmount
    + gstAmount;

  // =========================
  // MESSAGE
  // =========================

  let message = `
🏢 ${selectedBranchName}

🧾 *QUOTATION*

━━━━━━━━━━━━━━━

👤 *Customer:* ${selectedCustomer.name}
📞 *Phone:* ${selectedCustomer.phone}
📅 *Date:* ${billDate}

━━━━━━━━━━━━━━━
`;

  // =========================
  // PRODUCTS
  // =========================

  cart.forEach((item, index) => {

    const calc =
      calculateItem(item);

    message += `
🔹 *${index + 1}. ${item.name}*

📦 Box : ${item.box || 0}
🧩 Pcs : ${item.pic || 0}

📐 Sqft : ${calc.sqft.toFixed(2)}

💵 Rate : ₹${item.rate}

💰 Amount : ₹${calc.total.toFixed(2)}

━━━━━━━━━━━━━━━
`;

  });

  // =========================
  // BILL SUMMARY
  // =========================

  message += `
🧾 *BILL SUMMARY*

Subtotal : ₹${grandTotal.toFixed(2)}

Discount : ₹${discountAmount.toFixed(2)}

GST : ₹${gstAmount.toFixed(2)}

━━━━━━━━━━━━━━━

💚 *NET TOTAL : ₹${netTotal.toFixed(2)}*

🙏 Thank You Visit Again
`;

  // =========================
  // PHONE FORMAT
  // =========================

  let phone =
    selectedCustomer.phone.replace(
      /\D/g,
      ""
    );

  if (phone.length === 10) {

    phone = "91" + phone;

  }

  // =========================
  // OPEN WHATSAPP
  // =========================

  const url =
    `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");

};

return (
  <div className="bg-gray-100 min-h-screen p-2 md:p-4">

    {/* OFFLINE */}
    {!navigator.onLine && (
      <div className="bg-red-500 text-white text-center p-1 text-sm mb-2">
        🔴 Offline Mode
      </div>
    )}

    {/* TOP BAR */}
    <div className="bg-cyan-600 text-white p-2 md:p-3 rounded flex flex-col md:flex-row justify-between gap-2">
      <div className="flex flex-wrap gap-2 items-center">
       <input
  type="date"
  value={billDate}
  onChange={(e) => setBillDate(e.target.value)}
  className="text-black px-2 py-1 rounded"
/>

        <select 
          value={selectedBranch}
  onChange={(e) =>
    setSelectPayment(e.target.value)
  }className="text-black px-2 py-1 rounded">
          <option>Cash</option>
          <option>UPI</option>
          <option>Card</option>
        </select>
        {/* <select
  value={selectedBranch}
  onChange={(e) =>
    setSelectedBranch(e.target.value)
  }
  className="text-black px-2 py-1 rounded"
>
  <option value="A K Ceramic World">
    A K Ceramic World
  </option>

  <option value="A K Tiles Park">
    A K Tiles Park
  </option>
</select> */}

       {!quotationId && (
  <button
    onClick={handleStart}
    className="bg-green-500 px-3 py-1 rounded text-sm"
  >
    Start
  </button>
)}
{quotationId && (
  <button
    onClick={handleEnd}
    className="bg-blue-500 px-3 py-1 rounded text-sm"
  >
    End
  </button>
)}
        <button onClick={handleEnd} className="bg-red-500 px-3 py-1 rounded text-sm">Cancel</button>

         {/* ADD PRODUCT BUTTON */}
    <button
      type="button"
      onClick={() =>
        setShowProductModal(true)
      }
      className="
        bg-green-600
        hover:bg-green-700
        text-white
        px-4
        py-2
        rounded-2xl
        text-sm
        font-semibold
        whitespace-nowrap
      "
    >
      + Add Product
    </button>
      </div>

     <div className="text-center md:text-right">
  <h1 className="font-bold">
    {selectedBranchName}
  </h1>
</div>
    </div>

    {/* SEARCH + BILL */}
    <div className="grid md:grid-cols-3 gap-2 mt-2">

      {/* SEARCH */}
      <div className="md:col-span-2 bg-white p-3 rounded shadow relative">

        <input
          placeholder="Search Product / Code"
          className="w-full border p-2 md:p-3 rounded"
          value={search}
          onChange={(e)=>setSearch(e.target.value)}
        />

        {search && (
          <div className="absolute bg-white border w-full max-h-60 overflow-auto z-50">
            {filtered.map(p => (
              <div
                key={p.product_id}
                onClick={()=>{
                  addProduct(p);
                  setSearch("");
                }}
                className="p-2 hover:bg-gray-100 cursor-pointer"
              >
                {p.product_name} - {p.qty}- {p.branch}
              </div>
            ))}
          </div>
        )}

        <button
          onClick={()=>setShowScanner(!showScanner)}
          className="bg-blue-500 text-white w-full mt-2 py-2 rounded"
        >
          📷 Scanner
        </button>

        {showScanner && <div id="qr-reader" className="mt-2" />}
      </div>

      {/* BILL */}
      <div className="bg-white p-3 rounded shadow text-center">
        <p>Items: {cart.length}</p>
         <p>Quotation ID: {quotationId || "-"}</p>
        <h1 className="text-3xl md:text-4xl font-bold">
          ₹{grandTotal.toFixed(2)}
        </h1>
      </div>
    </div>

    {/* TABLE / MOBILE LIST */}
    <div className="bg-white mt-2 rounded shadow p-2 overflow-x-auto">

      {/* DESKTOP TABLE */}
      <table className="w-full text-sm hidden md:table">
        <thead className="bg-cyan-600 text-black">
          <tr>
            <th>Name</th>
            <th></th>
            <th></th>
            <th>Pcs/Box</th>
            <th>Sqft/Box</th>
            <th>Sqft</th>
            <th>Rate</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>

       <tbody>
  {cart.map(item => {
    const calc = calculateItem(item);

    return (
      <tr key={item.product_id} className="border-t text-center">

        {/* NAME (LEFT ALIGN) */}
        <td className="text-left px-2 font-medium">
          {item.name}
        </td>

   <td>
  <div className="flex items-center justify-center">
    
    <span className="font-medium text-sm mr-2">
      Box
    </span>

    <input
      type="number"
      value={item.box || 0}
      onChange={(e) =>
        updateItem(
          item.product_id,
          "box",
          e.target.value
        )
      }
      className="w-16 ml-2 border rounded text-center py-1"
    />

  </div>
</td>

<td>
  <div className="flex items-center justify-center">
    
    <span className="font-medium text-sm mr-2">
      Pcs
    </span>

    <input
      type="number"
      value={item.pic || 0}
      onChange={(e) =>
        updateItem(
          item.product_id,
          "pic",
          e.target.value
        )
      }
      className="w-16 ml-2 border rounded text-center py-1"
    />

  </div>
</td>

        {/* PCS/BOX */}
        <td className="text-left px-2 font-medium">
          {item.pcs_per_box}
        </td>

        {/* SQFT/BOX */}
        <td className="text-left px-2 font-medium">
          {item.sqft_per_box}
        </td>

        {/* SQFT */}
        <td className="text-left px-2 font-medium font-medium">
          {calc.sqft.toFixed(2)}
        </td>

        {/* RATE */}
        <td className="text-left px-2 font-medium">
          <input
            type="number"
            value={item.rate}
            onChange={(e)=>updateItem(item.product_id,"rate",e.target.value)}
            className="w-20 border text-center rounded"
          />
        </td>

        {/* TOTAL */}
        <td className="text-green-600 font-bold text-left px-2 font-medium">
          ₹{calc.total.toFixed(2)}
        </td>

        {/* DELETE */}
        <td className="text-left px-2 font-medium">
          <button
            onClick={()=>removeItem(item.product_id)}
            className="text-red-500 hover:scale-110"
          >
            ❌
          </button>
        </td>

      </tr>
    );
  })}
</tbody>
      </table>

      {/* MOBILE LIST */}
    <div className="md:hidden space-y-3">
  {cart.map((item) => {

    const calc = calculateItem(item);

    return (
      <div
        key={item.product_id}
        className="bg-white border rounded-xl p-4 shadow-sm"
      >

        {/* PRODUCT NAME */}
        <h3 className="font-bold text-lg mb-3">
          {item.name}
        </h3>

        {/* BOX + PCS */}
        <div className="grid grid-cols-3 gap-3 mb-3">

  {/* BOX */}
  <div>
    <label className="text-sm font-medium text-gray-600">
      Box
    </label>

    <input
      type="number"
      value={item.box || 0}
      onChange={(e) =>
        updateItem(
          item.product_id,
          "box",
          e.target.value
        )
      }
      className="
        border
        w-full
        rounded-lg
        p-2
        text-center
        mt-1
      "
    />
  </div>

  {/* PCS */}
  <div>
    <label className="text-sm font-medium text-gray-600">
      Pcs
    </label>

    <input
      type="number"
      value={item.pic || 0}
      onChange={(e) =>
        updateItem(
          item.product_id,
          "pic",
          e.target.value
        )
      }
      className="
        border
        w-full
        rounded-lg
        p-2
        text-center
        mt-1
      "
    />
  </div>

  {/* RATE */}
  <div>
    <label className="text-sm font-medium text-gray-600">
      Rate
    </label>

    <input
      type="number"
      value={item.rate || 0}
      onChange={(e) =>
        updateItem(
          item.product_id,
          "rate",
          e.target.value
        )
      }
      className="
        border
        w-full
        rounded-lg
        p-2
        text-center
        mt-1
      "
    />
  </div>

</div>

        {/* DETAILS */}
        <div className="space-y-1 text-sm mb-3">

          <div className="flex justify-between">
            <span>Pcs/Box</span>
            <span className="font-medium">
              {item.pcs_per_box}
            </span>
          </div>

          <div className="flex justify-between">
            <span>Sqft/Box</span>
            <span className="font-medium">
              {item.sqft_per_box}
            </span>
          </div>

          <div className="flex justify-between">
            <span>Sqft</span>
            <span className="font-bold text-blue-600">
              {calc.sqft.toFixed(2)}
            </span>
          </div>

        </div>

        {/* TOTAL + DELETE */}
        <div className="flex justify-between items-center">

          <p className="text-green-600 font-bold text-lg">
            ₹{calc.total.toFixed(2)}
          </p>

          <button
            onClick={() =>
              removeItem(item.product_id)
            }
            className="
              bg-red-500
              text-white
              px-4
              py-2
              rounded-lg
            "
          >
            Remove
          </button>

        </div>

      </div>
    );

  })}
</div>
    </div>

    {/* CUSTOMER + TOTAL */}
    <div className="grid md:grid-cols-3 gap-2 mt-2">

      {/* CUSTOMER */}
      <div className="bg-white p-3 rounded shadow relative">
        <input
          placeholder="Search Customer"
          value={customerSearch}
          onChange={(e)=>{
            setCustomerSearch(e.target.value);
            setShowCustomerList(true);
          }}
          className="border p-2 w-full rounded"
        />

        {showCustomerList && (
          <div className="absolute bg-white border w-full max-h-40 overflow-auto z-50">
            {filteredCustomers.map(c=>(
              <div
                key={c.customer_id}
                onClick={()=>{
                  setSelectedCustomer(c);
                  setCustomerSearch(c.name);
                  setShowCustomerList(false);
                }}
                className="p-2 hover:bg-gray-100 cursor-pointer"
              >
                {c.name} - {c.phone}
              </div>
            ))}
          </div>
        )}

        <button
          onClick={()=>setShowAddCustomer(true)}
          className="bg-blue-500 text-white w-full mt-2 py-2 rounded"
        >
          + Add Customer
        </button>

          {selectedCustomer && (
    <div className="bg-gray-50 p-2 rounded text-sm">
      <p><b>{selectedCustomer.name}</b></p>
      <p>{selectedCustomer.phone}</p>
      <p>{selectedCustomer.address}</p>
      <p>{selectedCustomer.gst_no}</p>
    </div>
  )}
      </div>

      {/* TOTAL */}
    <div className="bg-white p-4 rounded shadow">

  {/* TOTAL */}
  <div className="flex justify-between mb-3">
    <p className="font-medium">
      Total
    </p>

    <p className="font-bold">
      ₹{grandTotal.toFixed(2)}
    </p>
  </div>

 <div className="grid grid-cols-2 gap-3 mb-4">

  {/* DISCOUNT */}
  <div>

    <label className="text-sm text-gray-600">
      Discount
    </label>

    <input
      type="number"
      value={discount}
      onChange={(e) =>
        setDiscount(e.target.value)
      }
      placeholder="Discount"
      className="
        border
        w-full
        rounded-lg
        p-2
        mt-1
      "
    />

  </div>

  {/* GST */}
  <div>

    <label className="text-sm text-gray-600">
      GST Amount
    </label>

    <input
      type="number"
      value={gst}
      onChange={(e) =>
        setGst(e.target.value)
      }
      placeholder="GST"
      className="
        border
        w-full
        rounded-lg
        p-2
        mt-1
      "
    />

  </div>

</div>

  {/* NET TOTAL */}
  <div className="border-t pt-3">

    <div className="flex justify-between">

      <h2 className="font-bold text-xl">
        Net Total
      </h2>

      <h2 className="font-bold text-xl text-green-600">
        ₹{netTotal.toFixed(2)}
      </h2>

    </div>

  </div>

</div>

      {/* SAVE */}
      <div className="bg-white p-3 rounded shadow space-y-2">

  <button
    onClick={saveBill}
    className="bg-green-600 text-white w-full py-3 rounded text-lg"
  >
    SAVE BILL
  </button>

  <button
    onClick={sendWhatsAppBill}
    className="bg-green-500 text-white w-full py-2 rounded"
  >
    📲 Send WhatsApp
  </button>

</div>

    </div>

    {/* ADD CUSTOMER MODAL */}
    {showAddCustomer && (
      <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
        <div className="bg-white p-5 rounded w-80 space-y-3">

          <h2 className="font-bold">Add Customer</h2>

          <input
            placeholder="Name"
            value={newCustomer.name}
            onChange={(e)=>setNewCustomer({...newCustomer,name:e.target.value})}
            className="border p-2 w-full"
          />

          <input
            placeholder="Phone"
            value={newCustomer.phone}
            onChange={(e)=>setNewCustomer({...newCustomer,phone:e.target.value})}
            className="border p-2 w-full"
          />

          <input
            placeholder="Gst No"
            value={newCustomer.gst_no}
            onChange={(e)=>setNewCustomer({...newCustomer,gst_no:e.target.value})}
            className="border p-2 w-full"
          />

          <input
            placeholder="Email"
            value={newCustomer.email}
            onChange={(e)=>setNewCustomer({...newCustomer,email:e.target.value})}
            className="border p-2 w-full"
          />

          <textarea
            placeholder="Address"
            value={newCustomer.address}
            onChange={(e)=>setNewCustomer({...newCustomer,address:e.target.value})}
            className="border p-2 w-full"
          />

          <div className="flex gap-2">
            <button
              onClick={handleAddCustomer}
              className="bg-green-500 text-white flex-1 py-2 rounded"
            >
              Save
            </button>

            <button
              onClick={()=>setShowAddCustomer(false)}
              className="bg-gray-400 text-white flex-1 py-2 rounded"
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    )}

    <AnimatePresence>

  {showProductModal && (

    <motion.div
      className="
        fixed
        inset-0
        bg-black/70
        backdrop-blur-sm
        flex
        items-center
        justify-center
        z-[9999]
        p-3
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() =>
        setShowProductModal(false)
      }
    >

      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.9 }}
        onClick={(e) =>
          e.stopPropagation()
        }
        className="
          bg-white
          w-full
          max-w-5xl
          rounded-3xl
          p-6
          max-h-[95vh]
          overflow-y-auto
        "
      >

        <div className="
          flex
          justify-between
          items-center
          mb-6
        ">

          <h2 className="
            text-3xl
            font-bold
          ">
            Add Product
          </h2>

          <button
            onClick={() =>
              setShowProductModal(false)
            }
            className="text-3xl"
          >
            ✖
          </button>

        </div>

        <div className="
          grid
          md:grid-cols-2
          gap-4
        ">

          {/* PRODUCT NAME */}

          <div>

            <label>
              Product Name
            </label>

            <input
              type="text"
              name="product_name"
              value={
                productForm.product_name
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.product_name && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.product_name
                }
              </p>

            )}

          </div>

          {/* BRAND */}

          <div>

            <label>
              Brand
            </label>

            <select
              name="brand"
              value={
                productForm.brand
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >

             <option value="">Select Brand</option>
    <option value="Varmora">Varmora</option>
    <option value="Bonzer7">Bonzer 7</option>
    <option value="Hindware">Hindware</option>
    <option value="Somany">Somany</option>
    <option value="Sunheart">Sunheart</option>
    <option value="Bluezone">Bluezone</option>
    <option value="Active">Active</option>
    <option value="BX">BX</option>
    <option value="Simpolo">Simpolo</option>
    <option value="Captiva">Captiva</option>
    <option value="RJM">RJM</option>
    <option value="LIJO">LIJO</option>

            </select>

            {productErrors.brand && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.brand
                }
              </p>

            )}

          </div>

          {/* PRICE */}

          <div>

            <label>
              Price
            </label>

            <input
              type="number"
              name="price"
              value={
                productForm.price
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.price && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.price
                }
              </p>

            )}

          </div>
           <div>
              <label className="block mb-1 font-medium">MRP</label>
              <input
                type="number"
                name="mrp"
                value={productForm.mrp || ""}
                onChange={handleProductChange}
                className="input w-full"
              />
            </div>

        
<div>

  <label className="block mb-1 font-medium">
    Quantity
  </label>

  <div className="flex gap-2">

    {/* BOX */}

    <input
      type="number"
      name="qty"
      value={productForm.qty || ""}
      onChange={handleProductChange}
      placeholder="Box"
      className="
        w-1/2
        border
        p-3
        rounded-xl
        mt-1
      "
    />

    {/* PCS */}

    <input
      type="number"
      name="pic"
      value={productForm.pic || ""}
      onChange={handleProductChange}
      placeholder="Pcs"
      className="
        w-1/2
        border
        p-3
        rounded-xl
        mt-1
      "
    />

  </div>

  {productErrors.qty && (

    <p className="
      text-red-500
      text-sm
      mt-1
    ">
      {productErrors.qty}
    </p>

  )}

</div>

          {/* SIZE */}

          <div>

            <label>
              Tile Size
            </label>

            <select
              name="size"
              value={
                productForm.size
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >

             <option value="">Select Size</option>
    <option value="1200 x 600">1200 x 600</option>
    <option value="600 x 600">600 x 600</option>
    <option value="300 x 450">300 x 450</option>
    <option value="15 x 10">15 x 10</option>
    <option value="1200 x 200">1200 x 200</option>
    <option value="300 x 600">300 x 600</option>
    <option value="2400 x 1200">2400 x 1200</option>
    <option value="300 x 300">300 x 300</option>
    <option value="400 x 400">400 x 400</option>
    <option value="200 x 200">200 x 200</option>
    <option value="800 x 1600">800 x 1600</option>
    <option value="1200 x 1800">1200 x 1800</option>
    <option value="800 x 2400">800 x 2400</option>

            </select>

          </div>

           <div>
  <label className="block mb-1 font-medium text-gray-700">
    Supplier
  </label>

  <select
    name="supplier_id"
    value={productForm.supplier_id || ""}
    onChange={handleProductChange}
    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
  >
    <option value="">Select Supplier</option>

    {suppliers.map((item) => (
      <option
        key={item.supplier_id}
        value={item.supplier_id}
      >
        {item.supplier_name}
      </option>
    ))}
  </select>
</div>

          {/* FINISH */}

          <div>

            <label>
              Finish
            </label>

            <select
              name="finish"
              value={
                productForm.finish
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >

              <option value="">Select Finish</option>
    <option value="Glossy">Glossy</option>
    <option value="Matt">Matt</option>
    <option value="High Gloss">High Gloss</option>
    <option value="Polished">Polished</option>
    <option value="Carving">Carving</option>
    <option value="3D Elevation">3D Elevation</option>
    <option value="Rustic">Rustic</option>
    <option value="Wood">Wood</option>
    <option value="Stone">Stone</option>
    <option value="Anti Skid">Anti Skid</option>

            </select>

            {productErrors.finish && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.finish
                }
              </p>

            )}

          </div>

          {/* BRANCH */}

          <div>

            <label>
              Branch
            </label>

            <select
              name="branch"
              value={
                productForm.branch
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            >
<option value="">Select Finish</option>
    <option value="A K Ceramic World">A K Ceramic World</option>
    <option value="A K Tiles Park">A K Tiles Park</option>
    <option value="A K Tiles Park Green">A K Tiles Park Green</option>
    <option value="A K Tiles Park Main road">A K Tiles Park Main road</option>
    <option value="A K Tiles Park show room">A K Tiles Park show room</option>

            </select>

            {productErrors.branch && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.branch
                }
              </p>

            )}

          </div>

          {/* PCS */}

          <div>

            <label>
              Pcs per box
            </label>

            <input
              type="number"
              name="pcs_per_box"
              value={
                productForm.pcs_per_box
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.pcs_per_box && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.pcs_per_box
                }
              </p>

            )}

          </div>

          {/* SQFT BOX */}

          <div>

            <label>
              Sqft per box
            </label>

            <input
              type="number"
              name="sqft_per_box"
              value={
                productForm.sqft_per_box
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.sqft_per_box && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.sqft_per_box
                }
              </p>

            )}

          </div>

          {/* SQFT PCS */}

          <div>

            <label>
              Sqft per pcs
            </label>

            <input
              type="number"
              name="sqft_per_pcs"
              value={
                productForm.sqft_per_pcs
              }
              onChange={
                handleProductChange
              }
              className="
                w-full
                border
                p-3
                rounded-xl
                mt-1
              "
            />

            {productErrors.sqft_per_pcs && (

              <p className="
                text-red-500
                text-sm
                mt-1
              ">
                {
                  productErrors.sqft_per_pcs
                }
              </p>

            )}

          </div>

        </div>

        {/* DESCRIPTION */}

        <div className="mt-5">

          <label>
            Description
          </label>

          <textarea
            name="description"
            value={
              productForm.description
            }
            onChange={
              handleProductChange
            }
            className="
              w-full
              border
              p-3
              rounded-xl
              mt-1
            "
          />

        </div>

        {/* BUTTON */}

        <button
  type="button"
  onClick={() => {
    saveProduct();
  }}
  
  className="
    w-full
    mt-6
    bg-green-600
    hover:bg-green-700
    disabled:bg-gray-400
    text-white
    py-4
    rounded-2xl
    font-bold
  "
>
 Save
</button>

      </motion.div>

    </motion.div>

  )}

</AnimatePresence>

  </div>
);
}